var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.21 435.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#516076;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.93,359.32s53-266.8-127-316.8-529.71-143-466.35,326l58.35,67S220.93-213.87,600.93,359.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.93,359.32l-31.7,59.8S548.66,279,511.3,241.27l67.43-21.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.89,117.22s-70.44,2.89-75.82,77.78c0,0,82.49,12.4,99.38-73.72S322.89,117.22,322.89,117.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.82,122.48s65.41,26.31,45.39,98.69c0,0-81.87-15.94-68.95-102.75S350.82,122.48,350.82,122.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset27);
export default __webpack_public_path__ + "static/media/Asset 27.16a01a71.svg";
export { ForwardRef as ReactComponent };